// extracted by mini-css-extract-plugin
export var listingContainer = "JobListing-module--listingContainer--_15El";
export var locationContainer = "JobListing-module--locationContainer--3HxCt";
export var roleTypeContainer = "JobListing-module--roleTypeContainer--1f2dH";
export var roleContainer = "JobListing-module--roleContainer--U0NUS";
export var applyContainer = "JobListing-module--applyContainer--1ujiR";